export const text = [
    {
        category: "Infrastructure capacity",
        description: "Refers to the measures related to better utilisation of existing highway capacity",
        color: "#fbe4d5",
        subcategories: [
            {
                subcategory: "Traffic Management",
                description: "Refers to the measures related to improvements in traffic management, enabling full utilization of existing road capacity",
                types: [
                    {
                        type: "Speed management",
                        description: "Refers to measures influencing the speed of vehicles on highways, e.g., dynamic speed limit",
                    },
                    {
                        type: "Extreme weather management",
                        description: "Refers to measures which can be implemented during extreme weather events such as heavy fog, rain, snow etc",
                    },
                    {
                        type: "Road work management and safety",
                        description: "Refers to traffic management and safety-related measures during road works such as lane closure, speed management etc.",
                    },
                    {
                        type: "Hard shoulder and extra lane use",
                        description: "Refers to measures related to the use of the hard shoulder or extra lanes for extra capacity e.g., hard shoulder running",
                    },
                    {
                        type: "Ramp traffic management",
                        description: "Refers to measures related to the management of traffic within on and off ramps e.g., ramp metering",
                    },
                    {
                        type: "Lane use management",
                        description: "Refers to measures repurposing lane use e.g., reversible lane, high occupancy vehicle lane, moving road barriers etc.",
                    },
                    {
                        type: "Adaptive Traffic Management",
                        description: "Refers to traffic management strategies that change based on the situation on the highway, e.g., time of day, traffic flow etc.",
                    },
                    {
                        type: "ADAS management",
                        description: "Refers to measures within infrastructure facilitating efficient functioning of the ADAS and communication systems in the vehicle",
                    },
                    {
                        type: "Data driven traffic management",
                        description: "Refers to traffic management strategies based on insights from the data collected via different sources e.g., floating car data, loop detector data etc.",
                    },
                    {
                        type: "Traffic and route information",
                        description: "Refers to measures related to providing traffic and route information within the infrastructure to the road users",
                    },
                    {
                        type: "Traffic signals",
                        description: "Refers to traffic management via smart and effective traffic signalling strategies",
                    },
                ],
            },
            {
                subcategory: "Extend Infrastructure",
                description: "Refers to the measures related to extending the infrastructure without physical widening of the highway, such as better utilization of the existing space",
                types: [
                    {
                        type: "Roadside assets",
                        description: "Refers to measures related to improving/adding roadside assets to enable a more efficient flow of traffic",
                    },
                    {
                        type: "Extend physical infrastructure",
                        description: "Refers to measures related to the physical restructuring of the road to increase capacity",
                    },
                    {
                        type: "Extend digital infrastructure",
                        description: "Refers to measures enabling digital mapping of the infrastructure to facilitate new vehicle technologies",
                    },
                ],
            },
            {
                subcategory: "Infrastructure Design Quality",
                description: "Refers to the measures incorporating improvements in design and quality of the infrastructure, leading to more efficient traffic flows",
                types: [
                    {
                        type: "Lane design changes",
                        description: "Refers to the measures involving changes in lane design to facilitate efficient traffic flows",
                    },
                    {
                        type: "Clarity of environment",
                        description: "Refers to measures improving the clarity and readability of the environment to avoid human and machine error",
                    },
                ],
            },
        ],
    },

    {
        category: "Driver behaviour",
        description: "Refers to the measures related to improving driver behaviour to minimize human error and improving traffic flow efficiency",
        color: "#d9e2f3",
        subcategories: [
            {
                subcategory: "Driver Knowledge Awareness",
                description: "Refers to the measures improving the driver knowledge and awareness with the means of training and education",
                types: [
                    {
                        type: "Driver training and education",
                        description: "Refers to measures involving driver training to achieve efficient traffic flows",
                    },
                ],
            },
            {
                subcategory: "Human Behaviour and Infrastructure",
                description: "Refers to the measures intended to change human behaviour in the desired way leading to lesser human errors and reduction of congestion due to incidents",
                types: [
                    {
                        type: "Engineering Intervention (Nudging infrastructure)",
                        description: "Refers to measures incorporating nudging techniques to influence human behaviour",
                    },
                    {
                        type: "Enforcement Intervention (Rule enforcement techniques)",
                        description: "Refers to measures incorporating enforcement techniques to ensure rule compliance",
                    },
                    {
                        type: "Human factors",
                        description: "Refers to measures focusing on human factors perspectives to enable constructive behavioural changes",
                    },
                ],
            },
        ],
    },
    {
        category: "Vehicle Technology",
        description: "Refers to the measures related to the development of in-vehicle technologies and how they can contribute to realizing higher highway capacity",
        color: "#e2efd9",
        subcategories: [
            {
                subcategory: "Communication and ITS",
                description: "Refers to measures involving vehicle-infrastructure communication and ITS services, which might have an impact on road capacity",
                types: [
                    {
                        type: "C-ITS",
                        description: "Refers to measures incorporating C-ITS technology to ensure reliable communication between human-vehicle-infrastructure",
                    },
                    {
                        type: "Emergency communication devices",
                        description: "Refers to measures regarding the safety systems in vehicles in case of an emergency",
                    },
                    {
                        type: "Vehicle platooning",
                        description: "Refers to measures related to platooning of connected vehicles (or AVs)",
                    },
                    {
                        type: "Speed advisory",
                        description: "Refers to measures in providing speed advisory to the road users",
                    },
                    {
                        type: "Traffic and route information in vehicle",
                        description: "Refers to measures that provide traffic and route information to road users via in-vehicle systems",
                    },
                ],
            },
            {
                subcategory: "Driver Assistance Systems",
                description: "Refers to measures related to emerging technologies related to driver assistance systems and automated vehicles",
                types: [
                    {
                        type: "Advanced driver-assistance systems",
                        description: "Refers to measures incorporated for Advance driver assistance systems within vehicles",
                    },
                    {
                        type: "Automated vehicles",
                        description: "Refers to measures focusing on automated vehicles",
                    },
                ],
            },
        ],
    },
    {
        category: "Incident and Impact Management",
        description: "Refers to the measures to improve the incident and impact management, allowing avoiding capacity drop due to incident and faster recovery of capacity after the incident",
        color: "#fff2cc",
        subcategories: [
            {
                subcategory: "Post-incident management",
                description: "Refers to the measures focusing on detection, recovery and clearance in the event of an incident",
                types: [
                    {
                        type: "Access to emergency services",
                        description: "Refers to measures that enable easy access to emergency services in case of an incident",
                    },
                    {
                        type: "Institution’s co-operation",
                        description: "Refers to the cooperation strategies between different organizations for effective incident management",
                    },
                    {
                        type: "Site clearance",
                        description: "Refers to the measures enabling quick and efficient clearing of the incident site to enable restoration of the traffic flow",
                    },
                    {
                        type: "Incident detection",
                        description: "Refers to measures enabling quick detection of the incident for faster response by emergency services",
                    },
                ],
            },
            {
                subcategory: "Incident Avoidance",
                description: "Refers to the measures and strategies intended to avoid incidents",
                types: [
                    {
                        type: "Strategy",
                        description: "Refers to strategies related to incident avoidance",
                    },
                    {
                        type: "Separation of slow and fast lanes",
                        description: "Refers to measures related to the separation of lanes with different speeds to avoid incidents",
                    },
                    {
                        type: "Tools and guidelines",
                        description: "Refers to tools and guidelines enabling prediction and analysis of accidents",
                    },
                ],
            },
        ],
    },
    {
        category: "Regulations",
        description: "Refers to the measures laid out in the form of and regulations to improve the highway capacity",
        color: "#ebe1eb",
        subcategories: [
            {
                subcategory: "Vehicle-related",
                description: "Refers to the regulations on vehicles",
                types: [
                    {
                        type: "HGV policies",
                        description: "Regulations and policies related to heavy goods vehicles",
                    },
                ],
            },
            {
                subcategory: "Incident-related",
                description: "Refers to the regulations in the event of an incident",
                types: [
                    {
                        type: "Guidelines",
                        description: "Guidelines to enable pro-active incident management",
                    },

                    {
                        type: "Clearance",
                        description: "Regulations imposed to facilitate clearance on incident site",
                    },
                ],
            },
            {
                subcategory: "Infrastructure-related",
                description: "Refers to the regulations with a focus on infrastructure",
                types: [
                    {
                        type: "Traffic regulations",
                        description: "Refers to various regulations imposed to control and manage traffic, e.g., rules, speed limits etc.",
                    },

                    {
                        type: "Congestion Pricing",
                        description: "Refers to regulations imposing pricing schemes during congestion hours",
                    },
                ],
            },
            {
                subcategory: "Driver behaviour-related",
                description: "Refers to regulation on drivers or intended to change driver behaviour",
                types: [
                    {
                        type: "Driver regulations",
                        description: "Refers to regulations imposed on drivers to influence driver behaviour in the desired way",
                    },
                ],
            },
        ],
    },
];
